import { createSlice } from "@reduxjs/toolkit";
import { type Config } from "kadow-jetpack-model";
import { type Dispatch } from "redux";
import OnboardingAPI from "../../app/03_Onboarding/helpers/OnboardingAPI";
import { type RootStateI } from "../index";
import { useSelector } from "react-redux";
import fetchAllManagedAccounts from "../../api/fetchAllManagedAccounts";
import { tt } from "../../utils/i18n/i18n";
import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";

export const useJetpackConfigSelector = () => {
  return useSelector((state: RootStateI) => state.jetpackConfig.config);
};

export interface JetpackConfigStateI {
  config: Config | null;
}

const initialState: JetpackConfigStateI = {
  config: null
};

export const getJetpackConfig =
  (accountToDisplay: ManagedAccount) => async (dispatch: Dispatch) => {
    if (!accountToDisplay?.trackingID || !accountToDisplay?.token) {
      return;
    }

    try {
      const res = await OnboardingAPI.getJetpackDraftConfig(accountToDisplay);
      if (res) {
        dispatch(setJetpackConfig(res));
      }
    } catch (e) {
      console.error(e);
    }
  };

export const updateJetpackConfigThunk =
  (
    update: Partial<Config>,
    _id?: string,
    token?: string,
    isUpdateCustomer?: boolean
  ) =>
  async (dispatch: Dispatch, getState: () => RootStateI) => {
    const masterToken = getState().user.masterToken;

    if (!_id || !masterToken || !token) {
      return;
    }

    try {
      const config = await OnboardingAPI.updateJetpackDraftConfig(
        _id,
        token,
        update
      );

      dispatch(setJetpackConfig(config));

      if (isUpdateCustomer) {
        void fetchAllManagedAccounts({})(dispatch, getState);
      }
    } catch (e) {
      console.error(`${e}-123`);
      alert(tt("jetpackConfigUpdateError"));
    }
  };

const jetpackConfigSlice = createSlice({
  name: "jetpackConfig",
  initialState,
  reducers: {
    setJetpackConfig: (state, action) => {
      state.config = action.payload;
    }
  }
});

export default jetpackConfigSlice.reducer;
export const { setJetpackConfig } = jetpackConfigSlice.actions;
